var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvisor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 209 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5390_26645)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.998 56.4622C204.829 56.4622 204.997 57.6293 204.837 57.6452C187.587 58.1527 196.743 84.6464 182.766 84.6464C168.79 84.6464 171.48 53.5581 157.371 53.5581C143.262 53.5581 149.846 102.744 131.975 102.744C114.105 102.744 123.51 4.37207 106.58 4.37207C89.6497 4.37207 98.1148 64.8197 81.1845 64.8197C64.2542 64.8197 71.7788 21.7085 55.789 21.7085C39.7993 21.7085 44.5021 91.784 31.3341 91.784C18.1661 91.784 19.0502 59.8392 6.74751 57.0793C6.19258 56.9524 5.60942 56.889 4.99805 56.889",
    stroke: "#F1D3BD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.294 133.031C203.973 133.031 200.767 132.825 203.647 133.349C194.068 132.709 194.3 120.943 181.481 120.943C168.663 120.943 170.146 85.4619 155.976 85.4619C141.807 85.4619 140.862 133.106 130.471 133.106C120.08 133.106 117.247 106.208 104.966 106.208C92.6862 106.208 93.6309 130.062 79.4615 130.062C65.2921 130.062 68.1259 82.3411 53.9565 82.3411C39.7872 82.3411 39.7872 116.389 28.4516 116.389C17.1161 116.389 17.6505 101.015 5.31365 100.273C5.01137 100.248 5.31922 100.513 4.99805 100.513",
    stroke: "#F1D3BD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6173 60.4807C45.1177 60.4807 47.9554 57.5445 47.9554 53.9225C47.9554 50.3006 45.1177 47.3644 41.6173 47.3644C38.1169 47.3644 35.2793 50.3006 35.2793 53.9225C35.2793 57.5445 38.1169 60.4807 41.6173 60.4807Z",
    fill: "#EBB792"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.055 139.907C134.555 139.907 137.393 136.971 137.393 133.349C137.393 129.727 134.555 126.791 131.055 126.791C127.554 126.791 124.717 129.727 124.717 133.349C124.717 136.971 127.554 139.907 131.055 139.907Z",
    fill: "#EBB792"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5390_26645",
    x: 0.998047,
    y: 0,
    width: 208,
    height: 196,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5390_26645"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5390_26645",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5390_26645",
    x1: 215.209,
    y1: -8.73425,
    x2: -20.788,
    y2: 149.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CB59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9446"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisor);
export default __webpack_public_path__ + "static/media/advisor.623ff4e80dc75877d409465a15f8dd95.svg";
export { ForwardRef as ReactComponent };